
import {
    SET_EMBEDDINGS,
} from './types';

import { apiCallV2, servicesAPICall } from "../../utils/api";

export const GetEmbeddings = (page, count, filter, sort) => async (dispatch) => {
    const res = await servicesAPICall(
        "GET",
        "embeddings/get-resources",
        "",
        localStorage.getItem("access-token"),
        {
        },
        false
    );

    return [...res.data.data.programs] || [];

    // dispatch({
    //     type: SET_EMBEDDINGS,
    //     data: {
    //         list: res.data.data.programs,
    //     }
    // })

}

export const SaveProgramSummary = (program) => async (dispatch) => {

    const res = await servicesAPICall(
        "POST",
        "embeddings/save-summary",
        {
            program: program,
        },
        localStorage.getItem("access-token"),
    );

    return {
        success: res.data.status == 200 && res.status == 200,
        program: program,
    }
}

export const SendQuery = (query) => async (dispatch) => {

    const res = await servicesAPICall(
        "POST",
        "embeddings/program-similarity-search",
        {
            query: query,
        },
        localStorage.getItem("access-token"),
    );

    return {
        success: res.data.status == 200 && res.status == 200,
        results: res.data.data.results,
    }
}
